<div class="db-mobile-disclaimer">
  <div class="db-mobile-disclaimer-header" [ngClass]="{'db-mobile-disclaimer-header-optimizer': userSubscription?.subscriptionId === userSubscriptionIds.TRIAL_OPTIMIZER}">
    <img src="assets/images/logos/10web_name_logo_dark.svg" alt=""/>
  </div>
  <div class="db-mobile-disclaimer-body">
    <div class="db-mobile-disclaimer-body-message-image-wrap">
      <img src="assets/images/illustrations/magic_link_message.svg" alt=""/>
    </div>
    <div class="db-mobile-disclaimer-body-welcome-title" *ngIf="userSubscription?.subscriptionId === userSubscriptionIds.TRIAL || userSubscription?.subscriptionId === userSubscriptionIds.TRIAL_OPTIMIZER" [innerHTML]="'text_mobileDisclaimerWelcomeTitleTrial' | dbText"></div>
    <div class="db-mobile-disclaimer-body-main-title" [innerHTML]="'text_mobileDisclaimerMainTitle' | dbText"></div>
    <div *ngIf="userSubscription?.subscriptionId === userSubscriptionIds.TRIAL" class="db-mobile-disclaimer-body-desc" [innerHTML]="'text_mobileDisclaimerDescTrial' | dbText"></div>
    <div *ngIf="userSubscription?.subscriptionId === userSubscriptionIds.TRIAL_OPTIMIZER" class="db-mobile-disclaimer-body-desc" [innerHTML]="'text_mobileDisclaimerDescOptimizer' | dbText"></div>
  </div>
  <div class="db-mobile-disclaimer-footer" *ngIf="userSubscription?.subscriptionId !== userSubscriptionIds.TRIAL_OPTIMIZER">
    <div class="db-mobile-disclaimer-footer-steps" *ngFor="let automatedStep of automatedSteps">
      <div class="db-mobile-disclaimer-footer-step-icon"><i class="db-icon db-icon-checkbox-round"></i></div>
      <div class="db-mobile-disclaimer-footer-step-text" [innerHTML]="automatedStep"></div>
    </div>
  </div>
</div>
